var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCodes = function SvgCodes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 512 512",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M119 309c-2,0 -4,-1 -6,-2l-31 -32 0 46c0,10 -16,10 -16,0l0 -46 -32 32c-8,7 -20,-4 -12,-11l32 -32 -45 0c-10,0 -10,-16 0,-16l46 0 -33 -32c-7,-8 4,-19 11,-12l33 33 0 -46c0,-10 16,-10 16,0l0 45 31 -32c8,-7 19,4 12,12l-33 32 46 0c11,0 10,16 0,16l-45 0 32 32c5,5 1,13 -6,13zm311 12l0 -46 -32 32c-8,7 -19,-4 -11,-11l32 -32 -45 0c-11,0 -11,-16 0,-16l46 0 -33 -32c-8,-8 4,-19 11,-12l32 32 0 -45c0,-10 16,-10 16,0l0 45 32 -32c8,-7 19,4 12,12l-33 32 46 0c10,0 10,16 0,16l-45 0 32 32c7,7 -4,18 -12,11l-32 -32 0 46c0,10 -16,10 -16,0zm-182 0l0 -46 -32 32c-7,7 -19,-4 -11,-11l31 -32 -45 0c-10,0 -10,-16 0,-16l46 0 -32 -32c-8,-8 4,-19 11,-12l32 32 0 -45c0,-10 16,-10 16,0l0 45 32 -32c7,-7 19,4 11,12l-32 32 45 0c11,0 11,16 0,16l-44 0 31 32c8,7 -4,18 -11,11l-32 -32 0 46c1,9 -16,11 -16,0z"
  }))));
};
export default SvgCodes;